module.exports = __webpack_public_path__ + "img/news-title-sm.6288171f.png";